import { Navigate } from 'react-router-dom';
import ROUTES from '../../constants/routes';
import { useAuth } from '../contexts/AuthContext';

/**
 * Wrapper para rutas que requieren autenticación, rol ADMIN o permiso específico
 *
 * @param {Object} props - Propiedades del componente
 * @param {React.ReactNode} props.children - Componente a renderizar si autenticado
 * @param {boolean} props.isAuthenticated - Estado de autenticación
 * @param {boolean} [props.requireAdmin] - Si true, solo admins pueden acceder
 * @param {string} [props.permission] - Permiso requerido (ej: 'ordenes_trabajo.read_all')
 * @returns {JSX.Element}
 */
function ProtectedRoute({ children, isAuthenticated, requireAdmin = false, permission }) {
  const { isAdmin, hasPermission, permisosLoaded } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (requireAdmin && !isAdmin()) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  if (permission && !permisosLoaded) {
    return null;
  }

  if (permission && !hasPermission(permission)) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return children;
}

export default ProtectedRoute;
